import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navLinks = [
    { text: 'About', href: '/about', isRoute: true },
    { text: 'Summer Youth Program', href: '/summer-youth-program', isRoute: true },
    { text: 'Calendar', href: '/calendar', isRoute: true },
    { text: 'Be a Chaperone', href: '/chaperone', isRoute: true },
    { text: 'Contact Us', href: '/contact', isRoute: true },
    { text: 'Donate', href: 'https://zeffy.com/en-US/donation-form/donate-to-make-a-difference-18999', isRoute: false }
  ];

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/">
            <img src="/assets/logos/smallYSR.png" alt="Youth Supporting Roots Logo" />
          </Link>
        </div>
        
        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          <ul className="nav-list">
            {navLinks.map((link, index) => (
              <li key={index}>
                {link.isRoute ? (
                  <Link to={link.href} className="nav-link">
                    {link.text}
                  </Link>
                ) : (
                  <a 
                    href={link.href} 
                    className="nav-link"
                    target={link.href.startsWith('http') ? '_blank' : '_self'}
                    rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                  >
                    {link.text}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </nav>

        {/* Mobile Hamburger Button */}
        <button 
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Mobile Navigation */}
        <nav className={`mobile-nav ${isMenuOpen ? 'active' : ''}`}>
          <ul className="mobile-nav-list">
            {navLinks.map((link, index) => (
              <li key={index}>
                {link.isRoute ? (
                  <Link 
                    to={link.href} 
                    className="mobile-nav-link"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {link.text}
                  </Link>
                ) : (
                  <a 
                    href={link.href} 
                    className="mobile-nav-link"
                    target={link.href.startsWith('http') ? '_blank' : '_self'}
                    rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {link.text}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
